import apiClient from '../lib/apiClient';

const templateService = {
  list() {
    return apiClient.request('/templates');
  }
};

export default templateService;
